export default __webpack_public_path__ + "static/media/Avatar.29bcf7b8.png";